module.exports = __webpack_public_path__ + "static/media/festival_01.676dceea.jpg";